import React from 'react';
import Link from '../link';
import useIsThinLayout from '../../hooks/use-is-thin-layout';

interface Props {
  title: string;
  subtitle?: string;
  breadcrumb: { [key: string]: string };
  columns?: boolean;
}

const AccountLayout: React.FC<Props> = ({
  title,
  subtitle,
  breadcrumb,
  columns = true,
  children,
}) => {
  const { isThinLayout } = useIsThinLayout();

  return (
    <section>
      <div className={columns ? 'account-layout flex' : 'account-layout'}>
        <div className="title">
          {!isThinLayout && (
            <div className="breadcrumb">
              <Link href={breadcrumb.url}>
                <a>
                  <i className="fas fa-long-arrow-alt-left" /> {breadcrumb.text}
                </a>
              </Link>
            </div>
          )}
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {children}
      </div>
      {/* language=CSS */}
      <style jsx>{`
        section {
          width: 100%;
        }

        .account-layout {
          width: 100%;
        }

        .account-layout.flex {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }

        @media screen and (max-width: 850px) {
          .account-layout.flex {
            flex-wrap: wrap;
            gap: 1rem;
          }
        }

        .account-layout .title {
          flex: 1 0 40%;
        }

        @media screen and (max-width: 850px) {
          .account-layout .title {
            flex: 1 0 100%;
            padding: 0 2rem;
          }
        }

        .title h2 {
          margin: 0;
          font-family: 'Volvo Novum', sans-serif;
          font-weight: 400;
        }

        .title p {
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
        }

        .account-layout > :global(.content) {
          flex: 1 0 60%;
        }

        @media screen and (max-width: 850px) {
          .account-layout > :global(.content) {
            flex: 1 0 100%;
            padding: 0 2rem;
          }
        }

        .breadcrumb {
          margin-bottom: 1rem;
          font-size: 14px;
          font-family: 'Volvo Novum', sans-serif;
        }

        .breadcrumb a {
          color: #333;
          text-decoration: none;
          transition: all 0.2s linear;
        }

        .breadcrumb a:hover {
          color: #707070;
        }
      `}</style>
    </section>
  );
};

export default AccountLayout;
